import React, { useContext } from "react";
import "animate.css";
import ScrollAnimation from "react-animate-on-scroll";
// import Animate from 'animate.css-react';
import "animate.css/animate.compat.css"; // Import Animate.css styles
import uprightarrow from "../images/uprightarrow.png";
import GreenArrow from "../images/greenarrow.png";
import homeSegment4arrow from "../images/homeSegment4arrow.png";
import jobhero from "../images/jobhero.jpg";
import applicationform from "../images/ApplicationForm.pdf";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { SectionsContext } from "../store/section-context";
import logo from "../images/logo.png";

function Job() {
  const { careers } = useContext(SectionsContext);
  const { meta, hero, summary, jobOpenings, whyJoinUs, closing, vacancyImage } =
    careers;
  const iconClasses = [
    "fa-heart-circle-check",
    "fa-address-card",
    "fa-people-group",
    "fa-star",
    "fa-circle-check",
    "fa-hand-holding-heart",
    "fa-hands-helping",
    "fa-user-friends",
    "fa-user-check",
    "fa-heartbeat",
    "fa-user-shield",
    "fa-handshake",
    "fa-smile-beam",
    "fa-id-badge",
    "fa-users-cog",
    "fa-user-md",
    "fa-award",
    "fa-trophy",
    "fa-medal",
    "fa-thumbs-up",
  ];
  return (
    <div>
      <Helmet>
        {/* Title and Meta Description */}
        <title>{meta.title}</title>
        <meta name="description" content={meta.description} />
        <meta name="keywords" content={meta.keywords} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.description} />
        <meta
          property="og:url"
          content="https://www.brookshealthandcare.com/job"
        />
        <meta property="og:image" content={logo} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Brooks Health and Care" />
        <meta property="og:locale" content="en_GB" />{" "}
        <meta name="twitter:card" content="summary_large_image" />{" "}
        <meta name="twitter:title" content={meta.title} />
        <meta name="twitter:description" content={meta.description} />
        <meta name="twitter:image" content={logo} />
        <link
          rel="canonical"
          href="https://www.brookshealthandcare.com/"
        />{" "}
        <meta name="author" content="Brooks Health and Care" />
        <meta name="robots" content="index, follow" />{" "}
      </Helmet>
      <div
        className="aboutheroreplacement p-md-5 p-4"
        style={{
          backgroundImage: `url(${hero.uri || jobhero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          width: "100%",
          backgroundColor: "rgb(0 0 0 / 70%)",
        }}
      >
        <div className="aboutheroreplacementbox">
          <div className="lhsheading">
            {" "}
            <span className="thick-dot"></span>{" "}
            <span className="ps-1">{hero.headline}</span>{" "}
          </div>
          <div className="lhssubtitle pt-3">{hero.subheadline}</div>
        </div>
      </div>
      {/* ----------------JOB SEGMENT 1--------------- */}
      <div
        className="aboutsegment1 px-5  pt-4 pb-3"
        dangerouslySetInnerHTML={{ __html: summary }}
      ></div>
      <div className="horizontal-border-line pt-3"></div>
      <div className="greybg">
        {/* ----------------JOB SEGMENT 2--------------- */}
        <div className="jobsegment1 p-4 p-md-5">
          <div className="jobsegment2title">{jobOpenings.heading}</div>

          {jobOpenings.items.map((data, index) => (
            <div className="jobsegment2container pt-4  " key={index}>
              <div className="jobsegment2box p-md-5 p-3">
                <div className="d-flex jobsegment2sub1 ">
                  <div>
                    <div className="jobtitle pb-1">{data.title}</div>
                    <div className="jobsegment2desc py-2">{data.summary}</div>

                    <Link
                      to={{
                        pathname: `/jobdesc/${index}`,
                      }}
                      state={data}
                      className="homeSegment3contactcontainer pt-4"
                    >
                      <div className="homeSegment2contact pe-3">
                        See Full Details
                      </div>
                      <div>
                        <img className="" src={GreenArrow} alt="arrow" />
                      </div>
                    </Link>
                  </div>
                  <div className="pt-3 pt-md-5">
                    <a
                      href={applicationform}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="applicationlink"
                    >
                      <button className="testimonialbtn d-flex">
                        <span className="pe-2">Apply </span>{" "}
                        <img
                          src={uprightarrow}
                          alt="arrow"
                          className="homeSegment6testimoialarrow"
                        />
                      </button>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {vacancyImage && (
          <div className="vacancydiv">
            <img src={vacancyImage} className="vacancy" alt="" />
          </div>
        )}

        {/* ----------------JOB SEGMENT 3--------------- */}
        <div className="aboutsegment3 p-4 p-md-5">
          <div className="d-flex pt-5 ">
            <div className="homeSegment1aboutusline"></div>
            <div className="homeSegment1aboutus ps-2 ">{whyJoinUs.title}</div>
          </div>
          <div className="homeSegment3intro py-4">{whyJoinUs.intro}</div>
          <div className="aboutsegment3container">
            {whyJoinUs.items.map(({ title, description }, index) => (
              <ScrollAnimation
                key={index}
                className="aboutsegment3box"
                animateIn="bounceInUp"
                animationOut="fadeOut"
              >
                <div>
                  <i
                    className={`aboutsegment3icon fa-solid ${
                      iconClasses[index % iconClasses.length]
                    }`}
                  ></i>
                </div>
                <div className="aboutsegment3boxtitle py-3">{title}</div>
                <div className="aboutsegment3boxdesc">{description}</div>
              </ScrollAnimation>
            ))}
          </div>
        </div>
        {/* ----------------JOB SEGMENT 4--------------- */}
        <div className="jobsegment4 px-5 py-4">{closing}</div>
        {/* --------------HOME SEGMENT 4-------------- */}
        <div className="pb-5">
          <div className="homeSegment4 p-4 p-md-5">
            <div className="homeSegment4container p-4">
              <div>
                <div className="homeSegment4title">
                  If you have any questions about our job openings or the
                  application process{" "}
                </div>
                <div className="homeSegment4subtitle pt-2">
                  Please don't hesitate to contact us{" "}
                </div>
              </div>
              <Link
                to={`mailto: admin@brookshealthandcare.com?subject=Interested%20In%20Services&body=Hello!%20I'm%20interested%20in...`}
                className="homeSegment4contactUs"
              >
                Contact Us{" "}
                <img className="ps-2" src={homeSegment4arrow} alt="" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Job;
